/* import __COLOCATED_TEMPLATE__ from './edit-business-information.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { FieldIdentifier as AddressFieldIdentifier } from '@banking/ui/models/common/address';
import assert, { assertInstanceOf } from '@banking/ui/utils/assert';
import { BusinessFieldIdentifier } from '@banking/ui/models/checking/onboarding/edit-business-information';
import { EmployerIdentificationNumberFormatter, TextField } from 'field-kit';
let EditBusinessInformation = (_class = class EditBusinessInformation extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "ein", _descriptor2, this);
    _initializerDefineProperty(this, "confirmEin", _descriptor3, this);
    _initializerDefineProperty(this, "einErrorMessage", _descriptor4, this);
    _initializerDefineProperty(this, "confirmEinErrorMessage", _descriptor5, this);
    _defineProperty(this, "EIN_IDENTIFIER", BusinessFieldIdentifier.EIN);
    _defineProperty(this, "CONFIRM_EIN_IDENTIFIER", BusinessFieldIdentifier.CONFIRM_EIN);
    _defineProperty(this, "BUSINESS_NAME_IDENTIFIER", BusinessFieldIdentifier.BUSINESS_NAME);
  }
  handleCopyPersonalAddressCheckboxClicked(event) {
    this.args.userClickCopyPersonalAddress(event.detail.current === true);
  }
  async initializeFieldKit(fieldCandidate, marketInputTextElement) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && (fieldCandidate === BusinessFieldIdentifier.EIN || fieldCandidate === BusinessFieldIdentifier.CONFIRM_EIN));
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new EmployerIdentificationNumberFormatter();

    // Init the value for EIN input text, but do not init a value for CONFIRM_EIN
    if (this.args.initialEinValue && fieldCandidate === BusinessFieldIdentifier.EIN) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.args.initialEinValue);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => this.onInputChange(fieldCandidate, field.value());
    fieldKit.setDelegate({
      textDidChange
    });
  }
  onBusinessNameChange(fieldCandidate, event) {
    const fieldIdentifier = fieldCandidate;
    const val = assertInstanceOf(event, CustomEvent).detail.value;
    this.onInputChange(fieldIdentifier, val);
  }
  onInputChange(fieldCandidate, valueCandidate) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && (fieldCandidate in AddressFieldIdentifier || fieldCandidate in BusinessFieldIdentifier));
    // FIXME(steckel/jmah): Find a way to type-narrow over type-casting
    const field = fieldCandidate;
    assert(typeof valueCandidate === 'string');
    // FIXME(steckel/jmah): Find a way to type-narrow over type-casting
    const value = valueCandidate;
    this.args.onValueChange({
      field,
      value
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "ein", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "confirmEin", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "einErrorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "confirmEinErrorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleCopyPersonalAddressCheckboxClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCopyPersonalAddressCheckboxClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBusinessNameChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBusinessNameChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype)), _class);
export { EditBusinessInformation as default };